import Spacer from '@berlitz/spacer'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import StarRatings from '@berlitzplatforms/micro.ui.star-ratings'
import { AverageRatingWrapper } from './style'
import Skeleton from 'react-loading-skeleton'

export interface IPAverageRating {
  loading?: boolean
  rating?: number
}

const AverageRating: React.FC<IPAverageRating> = ({ loading, rating }) => (
  <AverageRatingWrapper>
    <StarRatings loading={loading} rating={rating} />
    <Spacer size="xxs" />
    {loading ? (
      <Skeleton width="100px" height="21px" />
    ) : (
      <FormattedMessage id="Average rating" defaultMessage="Average rating" />
    )}
  </AverageRatingWrapper>
)

export default AverageRating
